import React from 'react';
import { Palette } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const SIZES = ['12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px', '36px'];
const COLOURS = [
  ['Black', '#1F1F1F'], ['Grey', '#666666'], ['Red', '#C00000'], ['Orange', '#E26B0A'], ['Gold', '#B8860B'],
  ['Green', '#2E7D32'], ['Teal', '#00796B'], ['Blue', '#1F4E99'], ['Purple', '#6A1B9A'], ['Pink', '#AD1457'],
];

export const TextSizeSelect = ({ editor }) => {
  const current = editor.getAttributes('textStyle').fontSize || '';
  const options = current && !SIZES.includes(current) ? [current, ...SIZES] : SIZES;
  return (
    <select
      value={current}
      onChange={(e) => {
        const v = e.target.value;
        if (v) editor.chain().focus().setFontSize(v).run();
        else editor.chain().focus().unsetFontSize().run();
      }}
      title="Text size"
      className="shrink-0 h-7 rounded border border-[#E5E2DC] bg-white px-1 text-xs text-text-secondary cursor-pointer"
      data-testid="toolbar-font-size"
    >
      <option value="">Size</option>
      {options.map(s => <option key={s} value={s}>{s.replace('px', '')}</option>)}
    </select>
  );
};

export const ColorPicker = ({ editor }) => {
  const current = editor.getAttributes('textStyle').color;
  const apply = (c) => editor.chain().focus().setColor(c).run();
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          title="Text colour"
          className="shrink-0 p-1.5 rounded text-text-muted hover:bg-brand-primary/10 hover:text-text-primary flex flex-col items-center"
          data-testid="toolbar-color-btn"
        >
          <Palette className="w-4 h-4" />
          <span className="block w-4 h-0.5 mt-0.5 rounded" style={{ background: current || '#1F1F1F' }} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-56 p-3" align="start" data-testid="toolbar-color-popover">
        <div className="grid grid-cols-5 gap-2">
          {COLOURS.map(([name, hex]) => (
            <button
              key={hex}
              type="button"
              title={name}
              onClick={() => apply(hex)}
              className={`w-8 h-8 rounded-full border-2 ${current === hex ? 'border-brand-primary' : 'border-transparent'}`}
              style={{ background: hex }}
              data-testid={`toolbar-color-${name.toLowerCase()}`}
            />
          ))}
        </div>
        <div className="flex items-center justify-between mt-3 gap-2">
          <label className="flex items-center gap-1.5 text-xs text-text-secondary cursor-pointer">
            <input type="color" onChange={(e) => apply(e.target.value)} className="w-6 h-6 p-0 border-0" data-testid="toolbar-color-custom" />
            Custom
          </label>
          <button
            type="button"
            onClick={() => editor.chain().focus().unsetColor().run()}
            className="text-xs text-brand-accent hover:underline"
            data-testid="toolbar-color-reset"
          >
            Default colour
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
};
